import { Dialog, useDialog } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { TbDeviceFloppy } from "react-icons/tb";
import { MortgagePatchBodySchema } from "shared";
import { Api } from "@/api.config";
import { Button } from "@/components/Button";
import { TextField } from "@/components/form/TextField";
import { QueryKeys } from "@/LinkGen";
import { useMortgage } from "@/mortgages/hooks";

interface EditMortgageNoteProps {
  mortgageID: number;
}

export const EditMortgageNote = (props: EditMortgageNoteProps) => {
  const dialog = useDialog();
  const mortgage = useMortgage(props.mortgageID);

  const { handleSubmit, formState, control } = useForm({
    resolver: zodResolver(MortgagePatchBodySchema),
    defaultValues: {
      note: mortgage.note,
    },
  });
  const queryClient = useQueryClient();

  const onSubmit = handleSubmit(async (values) => {
    await Api.MortgagePatch(props.mortgageID, { note: values.note });

    await queryClient.refetchQueries({
      queryKey: QueryKeys.Mortgage(props.mortgageID),
    });
    dialog.close();
  });

  return (
    <form onSubmit={onSubmit}>
      <Dialog.Header>Edit note</Dialog.Header>
      <Dialog.Body>
        <TextField control={control} name="note" label="Note" />
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          icon={TbDeviceFloppy}
          type="submit"
          loading={formState.isSubmitting}
        >
          Save
        </Button>
      </Dialog.Footer>
    </form>
  );
};
